"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.setProvider = exports.setCancelParameters = exports.setAppointment = void 0;
const setAppointment = exports.setAppointment = '@action/SET_APPOINTMENT';
const setCancelParameters = exports.setCancelParameters = '@action/SET_CANCEL_PARAMETERS';
const setProvider = exports.setProvider = '@action/SET_PROVIDER';